module.exports = __webpack_public_path__ + "media/images/consumer/pages/recipes/ThanksgivingLTO/GreenBeanCasserole-0d4c6dd222c57c885f7da5b239e5f0ce.webp";